module.exports = __webpack_public_path__ + "img/IMG_4215_L_Black_MockedUp.08206b75.jpg";